import React, {useEffect, useState} from 'react';
import {ToggleButton, ToggleButtonGroup} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {connect} from "react-redux";
import Loader from "./layout/loading/loader";
import ButtonCreate from "./layout/ButtonCreate";
import Constants from "../../utils/constants";
import {campaignsActions} from "../../modules/campaigns/campaigns.actions";
import CampagneLavageTable from "./campaigns/lavage/CampagneLavageTable";
import TourneesGraffitiTable from "./campaigns/graffiti/TourneesGraffitiTable";
import {TravelExplore} from "@mui/icons-material";
import PageTitle from "./layout/PageTitle";
import CSVHandler from "../../utils/CSVHandler.js";
import {tourneesGraffitiActions} from "../../modules/tourneesGraffiti/tourneesGraffiti.actions";
import ClientSelectorV2 from "./patrimoine/ClientSelectorV2";
import {useGetClientsQuery} from "../../modules/users/clients.api";
import {campaignsApi, useGetCampaignsQuery} from "../../modules/campaigns/campaigns.api";

const LS_KEY_SELECTED_CLIENT = 'campaignsSelectedClientId';

function CampaignsPage({dispatch, ...props}) {
    const [viewType, setViewType] = useState(() => window.localStorage.getItem('campaignsViewType') || 'lavage'); // 'lavage' | 'graffiti'

    // Persistance localStorage de la sélection client (lavage)
    const [selectedClientId, setSelectedClientId] = useState(() => {
        const raw = window.localStorage.getItem(LS_KEY_SELECTED_CLIENT);
        return raw === null || raw === '' ? null : raw;
    });

    const handleSelectedClientChange = (id) => {
        if (id === null || id === undefined || id === '') {
            setSelectedClientId(null);
            window.localStorage.removeItem(LS_KEY_SELECTED_CLIENT);
        } else {
            setSelectedClientId(id);
            window.localStorage.setItem(LS_KEY_SELECTED_CLIENT, String(id));
        }
    };

    // Liste des clients pour le ClientSelectorV2 (RTK Query)
    const {data: clients = []} = useGetClientsQuery(undefined, {
        skip: viewType !== 'lavage',
    });

    // Campagnes lavage filtrées côté serveur via ?client=<id> (RTK Query)
    const {
        data: campaigns = [],
        isFetching: campaignsFetching,
    } = useGetCampaignsQuery(
        {clientId: selectedClientId},
        {skip: viewType !== 'lavage'},
    );

    // Vue graffiti : on conserve le workflow Redux legacy existant (hors scope)
    useEffect(() => {
        if (viewType === 'graffiti') {
            dispatch(tourneesGraffitiActions.fetchTourneesGraffiti());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viewType, dispatch]);

    const handleDelete = (campaign) => {
        dispatch(campaignsActions.deleteCampaign(campaign.id));
        // Invalide le cache RTK Query pour rafraîchir la liste (le thunk legacy ne le fait pas)
        dispatch(campaignsApi.util.invalidateTags([{type: 'Campaign', id: 'LIST'}]));
    }

    const handleOnPrint = (campaign, nextOccurence) => {
        dispatch(campaignsActions.fetchCampaign(campaign.id, (compaignWithConteneurs) => {
            CSVHandler.exportTourneeToExcel(compaignWithConteneurs, nextOccurence);
        }))
    }

    const handleDeleteGraffiti = (tournee) => {
        dispatch(tourneesGraffitiActions.deleteTourneeGraffiti(tournee.id));
    }

    return (
        <>
            <PageTitle title={"Gestion des tournées"} icon={<TravelExplore/>}/>
            <Grid container justifyContent={"space-between"} alignItems={"center"} className={"mb-1"}>
                <Grid item>
                    <ButtonCreate route={viewType === 'graffiti' ? Constants.APP_ROUTE_ADMIN_TOURNEES_GRAFFITI_NEW : Constants.APP_ROUTE_ADMIN_CAMPAIGNS_NEW} label="Créer une tournée"/>
                </Grid>
                <Grid item>
                    <ToggleButtonGroup
                        color={"primary"}
                        exclusive
                        size={"medium"}
                        value={viewType}
                        onChange={(e, v) => {
                            if (v) {
                                window.localStorage.setItem('campaignsViewType', v);
                                setViewType(v);
                            }
                        }}
                        aria-label={"Type de service"}
                    >
                        <ToggleButton value={'lavage'} className={viewType === 'lavage' ? "toggle-button button-selected-green" : "toggle-button"}>Lavage</ToggleButton>
                        <ToggleButton value={'graffiti'} className={viewType === 'graffiti' ? "toggle-button button-selected-orange" : "toggle-button"}>Graffiti</ToggleButton>
                    </ToggleButtonGroup>
                </Grid>
            </Grid>

            {viewType === 'lavage' && (
                <>
                    <Grid container size={12} alignItems={"center"} className={"mt-2 mb-2"}>
                        <Grid size={12}>
                            <ClientSelectorV2
                                inline
                                clients={clients}
                                clientSelected={selectedClientId}
                                onClientSelected={handleSelectedClientChange}
                                loading={campaignsFetching}
                            />
                        </Grid>
                    </Grid>
                    {campaignsFetching ? (
                        <Loader/>
                    ) : (
                        <CampagneLavageTable
                            campaigns={campaigns}
                            onDelete={handleDelete}
                            onPrint={handleOnPrint}
                        />
                    )}
                </>
            )}

            {viewType === 'graffiti' && (
                props.tourneesGraffitiLoading ? (
                    <Loader/>
                ) : (
                    <TourneesGraffitiTable
                        tournees={props.tourneesGraffiti || []}
                        loading={props.tourneesGraffitiLoading}
                        error={props.tourneesGraffitiError}
                        selectedClient={props.selectedClient}
                        onClientChange={(client) => dispatch(campaignsActions.setSelectedClient(client))}
                        onDelete={handleDeleteGraffiti}
                    />
                )
            )}
        </>
    )
}

const mapStateToProps = function (state) {
    return {
        selectedClient: state.campaigns.selectedClient,
        tourneesGraffiti: state.tourneesGraffiti.items,
        tourneesGraffitiLoading: state.tourneesGraffiti.loading,
        tourneesGraffitiError: state.tourneesGraffiti.error,
    }
}

export default connect(mapStateToProps)(CampaignsPage);
